module.exports = __webpack_public_path__ + "img/lg-想吃甜點是不需要理由的.bd7d1813.svg";